import { useState, useEffect, useRef } from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import Pagination from '../shared/pagination';
import { DateRangePicker } from '../shared/dateRangePicker';
import { toDateTimeString, durationBetweenString } from '../../utilities/dateUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import imageUtilities from '../../utilities/imageUtilities';

export default function Payments(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [similarityThreshold, setSimilarityThreshold] = useState(65);
    const [pageCount, setPageCount] = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const changeSimilarityThresholdTimeout = useRef();
    const changeSimilarityThreshold = function (x) {
        
        setSimilarityThreshold(Number(x));

        if (changeSimilarityThresholdTimeout.current) {
            clearTimeout(changeSimilarityThresholdTimeout.current);
            changeSimilarityThresholdTimeout.current = null;
        }

        changeSimilarityThresholdTimeout.current = setTimeout(() => {
            fetchPaymentsData(pageNumber, Number(x));
        }, 1000);
    };

    const fetchPaymentsData = (page, similarityThreshold) => {
        setIsLoading(true);

        Api.getPaymentsData(
            data => { setData(data); setIsLoading(false) },
            () => setIsLoading(false),
            props.vrm, props.siteId, props.paymentsFromDate, props.paymentsToDate, page, parseFloat(similarityThreshold / 100), 0, 1, null, props.organisationId, props.token
        )
    }
    useEffect(() => fetchPaymentsData(0, 65), []);

    useEffect(() => {
        if (!props.lookupDataInEdit) {
            fetchPaymentsData(pageNumber, similarityThreshold)
        }
    }, [props.vrm, pageNumber, props.siteId, props.paymentsFromDate, props.paymentsToDate]);

    const changepageNumber = (num) => {
        setPageNumber(num);
    };
    const isLastPage = () => {
        if (data && data !== undefined) {
            setLastPage(false)
            setPageCount(Math.ceil(data.totalCount / 100));
            if (pageNumber + 1 >= Math.ceil(data.totalCount / 100)) {
                setLastPage(true)
            }
        }
    };

    useEffect(() => isLastPage(), [data]);

    return <div className="card mb-3">
        <div className="card-header">
            <div className="row align-items-center px-md-3">
                    <div className="payments-accordion-header">
                        <h5 className="m-0">
                            <button className="button-no-style button-card-header collapsed" id="payments-accordion-button" type="button" data-toggle="collapse" data-target="#payments-list" aria-expanded="true" aria-controls="payments-list">
                                <p className='m-0'>Payments&nbsp;</p>
                                {
                                    isLoading
                                        ? <Loader classAddOn="p-0" />
                                        : <>
                                            { data &&
                                                <span className={ "translate-middle badge rounded-pill " + (data.totalCount > 0 ? "bg-success" : "bg-danger") }>
                                                    <>{ data.totalCount }</>
                                                </span>
                                            }
                                            &nbsp;<i className="fas fa-chevron-down"></i>
                                        </>

                                }
                            </button>
                        </h5>

                        <div className='payments-sliders'>
                            <div className='payments-slider'>
                                <label className='m-0'>Similarity: { similarityThreshold }%</label>
                                <input class="form-range" type="range" min="0" max="100" value={ similarityThreshold } onChange={ (e) => changeSimilarityThreshold(e.target.value) } />
                            </div>
                            <DateRangePicker 
                                fromDate={props.paymentsFromDate}
                                toDate={props.paymentsToDate}
                                setDateRange={(firstDate, lastDate) => {
                                    props.setPaymentsFromDate(firstDate);
                                    props.setPaymentsToDate(lastDate);
                                }}
                                showClearOption
                                dropdownPositionRight
                            />
                        </div>
                        <div className="payments-refresh">
                                <button
                                    className="btn btn-primary btn-sm ml-3 nowrap"
                                    onClick={ () => fetchPaymentsData(pageNumber, similarityThreshold) }>
                                    <i className="fas fa-redo"></i> Refresh
                                </button>
                        </div>
                    </div>
            </div>
        </div>
        <div className="card-body bg-light border-top details-container p-0 collapse" id="payments-list" aria-labelledby="Allow List" data-parent="#payments-accordion-button">
            { isLoading
                ? <Loader />
                : <>
                    {
                        data && data.items &&
                        <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>VRM</th>
                                        <th>Similarity</th>
                                        <th>Site</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Duration</th>
                                        <th className='text-right pr-4'>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        !arrayUtilities.isNullOrEmpty(data.items) && data.items
                                            .map(
                                                item => <tr key={ item.id }>
                                                    <td>
                                                        <span className="logo-container">{ imageUtilities.fetchPaymentProviderLogo(item.provider) }</span>
                                                    </td>
                                                    <td><h6 className="mb-0 small-number-plate">{ item.vrm }</h6></td>
                                                    <td>
                                                        <div class="progress" style={ { minWidth: "100px" } }>
                                                            <div
                                                                class={ `progress-bar text-left pl-1 ${ item.similarity > 0.99 ? "bg-success" : (item.similarity > 0.6 ? "bg-warning" : "bg-danger") }` }
                                                                role="progressbar"
                                                                style={ { width: `${ item.similarity * 100 }%` } }
                                                                aria-valuenow={ item.similarity }
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            >{ stringHelpers.formatDecimal((item.similarity * 100), 0) }%
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{ item.siteName }</td>
                                                    <td>{ toDateTimeString(item.start) }</td>
                                                    <td>{ toDateTimeString(item.end) }</td>
                                                    <td>{ durationBetweenString(item.start, item.end) }</td>
                                                    <td className='text-right pr-4'>{ stringHelpers.formatDecimal(item.amount, 2, "£") }</td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </>
            }
            <div className="d-flex justify-content-center row align-items-center pt-2">
                <div className="col-auto align-items-center">
                    <Pagination totalResults={ data?.totalCount } currentPage={ pageNumber } changePageNumber={ changepageNumber } />
                </div>
            </div>
        </div>
    </div>;
}